import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["accessibilityLabel", "id", "size", "testID", "UNSAFE_svgProps"];
import React from 'react';
import Surface from '@bubble-ui/primitive-surface';
import { Circle } from '@bubble-ui/primitive-circle';
import Shape from '@bubble-ui/primitive-shape';
import Rect from '@bubble-ui/primitive-rect';
import Defs from '@bubble-ui/primitive-defs';
import LinearGradient from '@bubble-ui/primitive-linear-gradient';
import Stop from '@bubble-ui/primitive-stop';
import withProvisionalOverrideFromContext from '@bubble-ui/hoc-with-provisional-override-from-context';
import { usePropsSpreadingDeprecationWarning } from '@bubble-ui/hook-use-props-spreading-deprecation-warning';
var ColoredIllustrationProductAssembly = _ref => {
  var {
      accessibilityLabel,
      id,
      size = 100,
      testID,
      UNSAFE_svgProps
      /**
       * @deprecated props spreading is outdated and will be removed with v7.0.0
       */
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  usePropsSpreadingDeprecationWarning({
    componentName: 'ColoredIllustrationProductAssembly',
    props,
    useInstead: 'UNSAFE_svgProps',
    removalDate: 'v7.0.0'
  });
  return /*#__PURE__*/React.createElement(Surface, _extends({
    id: id
  }, testID ? {
    testID
  } : {}, UNSAFE_svgProps, {
    accessibilityLabel: accessibilityLabel,
    fill: "none",
    viewBox: "0 0 100 100",
    width: size,
    height: size
  }, props), /*#__PURE__*/React.createElement(Shape, {
    fill: "url(#paint0_linear_5601_1403)",
    d: "M86.364 34H94a6 6 0 0 1 6 6v10.727a6 6 0 0 1-6 6h-7.636V34Z"
  }), /*#__PURE__*/React.createElement(Rect, {
    width: 4.545,
    height: 11.364,
    x: 10.227,
    y: 22.636,
    fill: "#EBD4FF",
    rx: 2.273
  }), /*#__PURE__*/React.createElement(Rect, {
    width: 4.545,
    height: 11.364,
    x: 19.318,
    y: 22.636,
    fill: "#EBD4FF",
    rx: 2.273
  }), /*#__PURE__*/React.createElement(Rect, {
    width: 4.545,
    height: 22.727,
    x: 86.364,
    y: 65.818,
    fill: "#EBD4FF",
    rx: 2.273,
    transform: "rotate(90 86.364 65.818)"
  }), /*#__PURE__*/React.createElement(Circle, {
    cx: 76.136,
    cy: 85.136,
    r: 5.682,
    fill: "#2A44C6"
  }), /*#__PURE__*/React.createElement(Circle, {
    cx: 17.045,
    cy: 85.136,
    r: 5.682,
    fill: "#2A44C6"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "url(#paint1_linear_5601_1403)",
    d: "M14.773 11.273a2.273 2.273 0 1 1 4.545 0V59h-4.545V11.273Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#9C9FA2",
    d: "M19.318 54.455a2.273 2.273 0 1 1 0 4.545H5.682a4.545 4.545 0 0 1 4.545-4.545h9.091Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "url(#paint2_linear_5601_1403)",
    d: "M5.682 17v22.091a4 4 0 0 0 4 4h13.954a3.636 3.636 0 0 0 3.637-3.636A5.455 5.455 0 0 1 32.727 34h11.819c5.522 0 10 4.477 10 10v10.682c0 5.523-4.478 10-10 10H10c-5.523 0-10 4.477-10 10v1.59c0 5.524 4.477 10 10 10h79.182a4 4 0 0 0 4-4V29c0-11.046-8.954-20-20-20h-59.5a8 8 0 0 0-8 8Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "url(#paint3_linear_5601_1403)",
    d: "M5.682 17v22.091a4 4 0 0 0 4 4h13.954a3.636 3.636 0 0 0 3.637-3.636A5.455 5.455 0 0 1 32.727 34h11.819c5.522 0 10 4.477 10 10v10.682c0 5.523-4.478 10-10 10H10c-5.523 0-10 4.477-10 10v1.59c0 5.524 4.477 10 10 10h79.182a4 4 0 0 0 4-4V29c0-11.046-8.954-20-20-20h-59.5a8 8 0 0 0-8 8Z"
  }), /*#__PURE__*/React.createElement(Circle, {
    cx: 77.273,
    cy: 49.909,
    r: 11.364,
    fill: "url(#paint4_linear_5601_1403)"
  }), /*#__PURE__*/React.createElement(Circle, {
    cx: 75,
    cy: 45.364,
    r: 11.364,
    fill: "url(#paint5_linear_5601_1403)"
  }), /*#__PURE__*/React.createElement(Circle, {
    cx: 75,
    cy: 45.364,
    r: 4.545,
    fill: "#2A44C6"
  }), /*#__PURE__*/React.createElement(Defs, null, /*#__PURE__*/React.createElement(LinearGradient, {
    id: "paint0_linear_5601_1403",
    x1: 93.182,
    x2: 93.182,
    y1: 34,
    y2: 47.636,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    stopColor: "#EBD4FF"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 1,
    stopColor: "#2A44C6"
  })), /*#__PURE__*/React.createElement(LinearGradient, {
    id: "paint1_linear_5601_1403",
    x1: 17.045,
    x2: 17.045,
    y1: 11.273,
    y2: 54.455,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    stopColor: "#C7C9CC"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 1,
    stopColor: "#93969A"
  })), /*#__PURE__*/React.createElement(LinearGradient, {
    id: "paint2_linear_5601_1403",
    x1: 3.409,
    x2: 97.727,
    y1: 10.136,
    y2: 88.546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    stopColor: "#FFD1FF"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 1,
    stopColor: "#4961FF"
  })), /*#__PURE__*/React.createElement(LinearGradient, {
    id: "paint3_linear_5601_1403",
    x1: 3.409,
    x2: 97.727,
    y1: 10.136,
    y2: 88.546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    stopColor: "#FFD1FF"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 1,
    stopColor: "#4961FF"
  })), /*#__PURE__*/React.createElement(LinearGradient, {
    id: "paint4_linear_5601_1403",
    x1: 69.318,
    x2: 84.091,
    y1: 38.545,
    y2: 60.136,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    stopColor: "#4951BF"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 1,
    stopColor: "#4951BF",
    stopOpacity: 0.22
  })), /*#__PURE__*/React.createElement(LinearGradient, {
    id: "paint5_linear_5601_1403",
    x1: 67.046,
    x2: 80.682,
    y1: 34,
    y2: 57.864,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    stopColor: "#EBD4FF"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 1,
    stopColor: "#9396FF"
  }))));
};
ColoredIllustrationProductAssembly.displayName = 'ColoredIllustrationProductAssembly';
export default withProvisionalOverrideFromContext(ColoredIllustrationProductAssembly);
//# sourceMappingURL=index.js.map